module.exports = "<p>\n  <button class=\"assign assign-logs-pane btn btn-xs \" href=\"#\">Assign devices</button>\n</p>\n"